import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcReviewH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 9c14.912 0 27 12.088 27 27 0 4.539-1.131 8.813-3.111 12.567L63.32 59.76c.67 2.185-1.376 4.23-3.561 3.56L48.57 59.886A26.86 26.86 0 0 1 36 63C21.088 63 9 50.912 9 36S21.088 9 36 9M24 39.75a2.25 2.25 0 0 0 0 4.5h18a2.25 2.25 0 0 0 0-4.5zm0-10.5a2.25 2.25 0 0 0 0 4.5h24a2.25 2.25 0 0 0 0-4.5z",
    clipRule: "evenodd"
  }));
}
var IcReviewH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcReviewH72));

export { IcReviewH72 as I };
